module.exports = __webpack_public_path__ + "img/insigne_logo_registro.bdd8fc69.png";